<template lang="pug">
div
  Form(:data="area", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useAreaAdd from './useAreaAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, area, isSubmitting } = useAreaAdd()

    return {
      area,
      create,
      isSubmitting,
    }
  },
}
</script>
